module.exports = __webpack_public_path__ + "img/api-economy-connector-1.f1ad6a6c.svg";